export default function phoneValidator(entry) {
  return entry.match(/^0(6|7)([0-9]{2}){4}$/)
}